import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import FilterAndClearUsers from "./FilterAndClearUsers";
import UsersTable from "./UsersTable";
import PaginationOfTable from "./PaginationOfTable"; // Import Pagination
import { useCallback } from "react";
// import CustomFiled from "./CustomFiled";
// import VerificationCode from "./VerificationCode";


const Userlogindatatable = () => {
  const [filters, setFilters] = useState({
    role: "",
    username: "",
    email: "",
    sort: "DESC",
  });
  const [data, setData] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  // Fetch Users Function
  const fetchUsers = useCallback(async (updatedFilters = filters) => {
  try {
    const response = await axios.get(
      `/api/v1/get-admin-users`,
      {
        params: {
          limit: rowsPerPage,
          page: page,
          username: updatedFilters.username || undefined,
          email: updatedFilters.email || undefined,
          role: updatedFilters.role || undefined,
          sort: updatedFilters.sort,
        },
      }
    );

    if (response.data && Array.isArray(response.data.users)) {
      setData(response.data.users);
      setTotalUsers(response.data.total);
    } else {
      toast.error("Failed to load user data.");
    }
  } catch (error) {
    toast.error("Error fetching data.");
  }
}, [filters, page, rowsPerPage]); // ✅ Dependencies
  // Re-fetch data when filters or page changes
useEffect(() => {
  fetchUsers();
}, [fetchUsers]);

  return (
    <div>
      {/* Filters Section */}
      <FilterAndClearUsers
        fetchUsers={fetchUsers}
        setFilters={setFilters}
        filters={filters}
      />

      {/* Table Section */}
      <UsersTable data={data} fetchUsers={fetchUsers} />

      {/* Pagination Component */}
      <PaginationOfTable
        page={page}
        setPage={setPage}
        totalUsers={totalUsers}
        rowsPerPage={rowsPerPage}
      />
        {/* <CustomFiled />
        <VerificationCode /> */}
    </div>
  
  );
};

export default Userlogindatatable;
